import { releaseCDNUrl, sanitizeScriptUrl } from "./sanitizeScriptUrl";
var policy;
export function trustedPolicy() {
    if (policy === undefined) {
        policy = null;
        if (typeof self !== "undefined" && self.trustedTypes) {
            try {
                policy = self.trustedTypes.createPolicy("@1js/midgard-trusted-types", {
                    createHTML: function (s) { return s; },
                    createScript: function (s) { return s; },
                    createScriptURL: function (url, publicPath) {
                        if (publicPath === void 0) { publicPath = releaseCDNUrl; }
                        return sanitizeScriptUrl(url, publicPath);
                    },
                });
            }
            catch (_a) {
                // trustedTypes.createPolicy throws if called with a name that is
                // already registered and allow-duplicates is not enabled,
                // even in report-only mode.
            }
        }
    }
    return policy;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJ1c3RlZFBvbGljeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy90cnVzdGVkUG9saWN5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxhQUFhLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxxQkFBcUIsQ0FBQztBQUV2RSxJQUFJLE1BQTRDLENBQUM7QUFFakQsTUFBTSxVQUFVLGFBQWE7SUFDM0IsSUFBSSxNQUFNLEtBQUssU0FBUyxFQUFFO1FBQ3hCLE1BQU0sR0FBRyxJQUFJLENBQUM7UUFDZCxJQUFJLE9BQU8sSUFBSSxLQUFLLFdBQVcsSUFBSSxJQUFJLENBQUMsWUFBWSxFQUFFO1lBQ3BELElBQUk7Z0JBQ0YsTUFBTSxHQUFHLElBQUksQ0FBQyxZQUFZLENBQUMsWUFBWSxDQUFDLDRCQUE0QixFQUFFO29CQUNwRSxVQUFVLEVBQUUsVUFBQyxDQUFTLElBQUssT0FBQSxDQUFDLEVBQUQsQ0FBQztvQkFDNUIsWUFBWSxFQUFFLFVBQUMsQ0FBUyxJQUFLLE9BQUEsQ0FBQyxFQUFELENBQUM7b0JBQzlCLGVBQWUsRUFBRSxVQUNmLEdBQVcsRUFDWCxVQUFrQzt3QkFBbEMsMkJBQUEsRUFBQSwwQkFBa0M7d0JBQ3ZCLE9BQUEsaUJBQWlCLENBQUMsR0FBRyxFQUFFLFVBQVUsQ0FBQztvQkFBbEMsQ0FBa0M7aUJBQ2hELENBQUMsQ0FBQzthQUNKO1lBQUMsV0FBTTtnQkFDTixpRUFBaUU7Z0JBQ2pFLDBEQUEwRDtnQkFDMUQsNEJBQTRCO2FBQzdCO1NBQ0Y7S0FDRjtJQUNELE9BQU8sTUFBTSxDQUFDO0FBQ2hCLENBQUMifQ==